import { jsx as r, jsxs as b } from "react/jsx-runtime";
import "react";
import { classNames as i } from "../../utilities/index.js";
const m = _ref => {
    let {
      legendText: s,
      className: t,
      children: d,
      hideLegend: a,
      required: l,
      noBox: e = !1,
      ...c
    } = _ref;
    const n = i({
        "sash-Fieldset text-black bg-white": !0,
        "border border-black px-3 pt-3": !e,
        [t]: t
      }),
      o = i({
        "sash-Legend leading-tight bg-white text-black font-semibold": !0,
        "px-1 text-xs": !e,
        "mb-2.5": e,
        "sr-only": a,
        "text-required": l
      });
    return /* @__PURE__ */r("div", {
      children: /* @__PURE__ */b("fieldset", {
        required: l,
        className: n,
        ...c,
        children: [s && /* @__PURE__ */r("legend", {
          className: o,
          children: s
        }), d]
      })
    });
  },
  x = m;
export { x as default };